<ng-container *ngIf="newBannerUI">
  <div class="tw-w-full tw-bg-gradient-dark-teal-to-light-teal tw-rounded-3" (click)="bannerClick()">
    <div class="tw-bg-white tw-rounded-[11px] tw-p-4 tw-flex tw-justify-between tw-items-center">
      <div class="tw-flex-1">
        <h1 *ngIf="regimenClass === ApiClientConstant.Regimen.Class.FACE" class="tw-font-bold tw-text-500 tw-font-lexend tw-mb-2 tw-text-nowrap" i18n="@@talkToSkinDoctor">Talk to a skin doctor</h1>
        <h1 *ngIf="regimenClass === ApiClientConstant.Regimen.Class.HAIR" class="tw-font-bold tw-text-500 tw-font-lexend tw-mb-2 tw-text-nowrap" i18n="@@talkToHairDoctor">Talk to a hair doctor</h1>
        <div class="tw-font-body tw-leading-4 tw-font-normal tw-text-200 tw-text-gray-500">
         <p
           *ngIf="showWorkingHours && regimenClass === ApiClientConstant.Regimen.Class.FACE"
           i18n="@@arrangeConsultationAfterWorkingHoursFace"
         >
           We will arrange an online consultation with a skin doctor within {{ hours }} {{ hours > 1 ? ' hours' : ' hour' }}.
         </p>
         <p
           *ngIf="showWorkingHours && regimenClass === ApiClientConstant.Regimen.Class.HAIR"
           i18n="@@arrangeConsultationAfterWorkingHoursHair"
         >
           We will arrange an online consultation with a hair doctor within {{ hours }} {{ hours > 1 ? ' hours' : ' hour' }}.
         </p>
         <p
           *ngIf="showTomorrowMorning && regimenClass === ApiClientConstant.Regimen.Class.FACE"
           i18n="@@arrangeConsultationAfterTomorrowMorningFace"
         >
           We will arrange an online consultation with a skin doctor tomorrow morning.
         </p>
         <p
           *ngIf="showTomorrowMorning && regimenClass === ApiClientConstant.Regimen.Class.HAIR"
           i18n="@@arrangeConsultationAfterTomorrowMorningHair"
         >
           We will arrange an online consultation with a hair doctor tomorrow morning.
         </p>
         <p
           *ngIf="showAfterNineAm && regimenClass === ApiClientConstant.Regimen.Class.FACE"
           i18n="@@arrangeConsultationAfter9amFace"
         >
           We will arrange an online consultation with a skin doctor after 9 am.
         </p>
         <p
           *ngIf="showAfterNineAm && regimenClass === ApiClientConstant.Regimen.Class.HAIR"
           i18n="@@arrangeConsultationAfter9amHair"
         >
           We will arrange an online consultation with a hair doctor after 9 am.
         </p>
       </div>
      </div>
      <div class="tw-flex tw-justify-end tw-items-center tw-gap-2">
        <img class="tw-w-20" src="/assets/icons/call-icons.svg" alt="phone icon">
      </div>
    </div>
    <div class="tw-w-full tw-flex tw-items-center tw-justify-between tw-px-3 tw-py-1.5">
      <p class="tw-text-white tw-font-bold tw-font-lexend tw-text-300" i18n="@@requestACall">Request a call</p>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
        stroke-width="2"
        class="tw-w-6 tw-text-white"
      >
        <path stroke-linecap="butt" stroke-linejoin="miter" d="M9 6l6 6-6 6" />
      </svg>
    </div>
  </div>
</ng-container>
<ng-container *ngIf="!newBannerUI">
  <ng-container *ngIf="supportView">
    <div class="tw-px-3 tw-pt-2 tw-rounded-3 tw-bg-white tw-font-body" (click)="bannerClick()">
      <h1 *ngIf="regimenClass === ApiClientConstant.Regimen.Class.FACE" class="tw-text-600 tw-font-lexend tw-font-normal tw-mb-2 tw-leading-6 tw-text-gray-800" i18n="@@talkToSkinDoctor">Talk to a skin doctor</h1>
      <h1 *ngIf="regimenClass === ApiClientConstant.Regimen.Class.HAIR" class="tw-text-600 tw-font-lexend tw-font-normal tw-mb-2 tw-leading-6 tw-text-gray-800" i18n="@@talkToHairDoctor">Talk to a hair doctor</h1>
      <p
        *ngIf="showWorkingHours && regimenClass === ApiClientConstant.Regimen.Class.FACE"
        i18n="@@arrangeConsultationAfterWorkingHoursFace"
        class="tw-font-body tw-leading-5 tw-font-normal tw-text-300 tw-text-gray-400 tw-mb-2"
      >
        We will arrange an online consultation with a skin doctor within {{ hours }} {{ hours > 1 ? 'hours' : 'hour' }}.
      </p>
      <p
        *ngIf="showWorkingHours && regimenClass === ApiClientConstant.Regimen.Class.HAIR"
        i18n="@@arrangeConsultationAfterWorkingHoursHair"
        class="tw-font-body tw-leading-5 tw-font-normal tw-text-300 tw-text-gray-400 tw-mb-2"
      >
        We will arrange an online consultation with a hair doctor within {{ hours }} {{ hours > 1 ? 'hours' : 'hour' }}.
      </p>
      <p
        *ngIf="showTomorrowMorning && regimenClass === ApiClientConstant.Regimen.Class.FACE"
        i18n="@@arrangeConsultationAfterTomorrowMorningFace"
        class="tw-font-body tw-leading-5 tw-font-normal tw-text-300 tw-text-gray-400 tw-mb-2"
      >
        We will arrange an online consultation with a skin doctor tomorrow morning.
      </p>
      <p
        *ngIf="showTomorrowMorning && regimenClass === ApiClientConstant.Regimen.Class.HAIR"
        i18n="@@arrangeConsultationAfterTomorrowMorningHair"
        class="tw-font-body tw-leading-5 tw-font-normal tw-text-300 tw-text-gray-400 tw-mb-2"
      >
        We will arrange an online consultation with a hair doctor tomorrow morning.
      </p>
      <p
        *ngIf="showAfterNineAm && regimenClass === ApiClientConstant.Regimen.Class.FACE"
        i18n="@@arrangeConsultationAfter9amFace"
        class="tw-font-body tw-leading-5 tw-font-normal tw-text-300 tw-text-gray-400 tw-mb-2"
      >
        We will arrange an online consultation with a skin doctor after 9 am.
      </p>
      <p
        *ngIf="showAfterNineAm && regimenClass === ApiClientConstant.Regimen.Class.HAIR"
        i18n="@@arrangeConsultationAfter9amHair"
        class="tw-font-body tw-leading-5 tw-font-normal tw-text-300 tw-text-gray-400 tw-mb-2"
      >
        We will arrange an online consultation with a hair doctor after 9 am.
      </p>
      <div class="tw-w-full tw-flex tw-justify-between tw-items-center tw-gap-4">
        <div class="tw-w-full tw-h-[1px] tw-bg-[#CECECE] tw-mb-4"></div>
        <span class="tw-flex tw-items-center">
        <img src="https://cdn.cureskin.com/app/img/doctor_ai.svg" class="tw-w-[35px] tw-h-[35px] -tw-mr-3" alt="doctor icon" />
        <img src="https://cdn.cureskin.com/app/img/phone_teal.svg" class="tw-w-[39px] tw-h-[39px]" alt="phone icon" />
      </span>
      </div>
      <span class="tw-w-fit tw-flex tw-items-center tw-gap-2 tw-font-bold tw-text-teal-600 -tw-mt-3">
      <h1 class="" i18n="@@requestACall">Request a call</h1>
      <span class="tw-h-4 tw-w-4 tw-text-teal-600">
            <svg viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M6.16185 15.4167L4.97852 14.2333L10.4618 8.75L4.97852 3.26667L6.16185 2.08334L12.8285 8.75L6.16185 15.4167Z" fill="currentColor"/>
            </svg>
          </span>
    </span>
    </div>
  </ng-container>
  <ng-container *ngIf="!supportView">
    <div class="tw-bg-white tw-pb-4">
      <h1 class="tw-text-400 tw-font-lexend" i18n="@@gotQuestionsNeedHelp">
        <span class="tw-font-bold tw-text-500">Got questions?</span> We are here to help
      </h1>
    </div>
    <div class="tw-p-4 tw-pt-5 tw-rounded-3 tw-bg-gray-250 tw-font-body" (click)="bannerClick()">
      <h1 *ngIf="regimenClass === ApiClientConstant.Regimen.Class.FACE" class="tw-text-600 tw-font-lexend tw-font-normal tw-mb-3 tw-leading-6 tw-text-gray-800" i18n="@@talkToSkinDoctor">Talk to a skin doctor</h1>
      <h1 *ngIf="regimenClass === ApiClientConstant.Regimen.Class.HAIR" class="tw-text-600 tw-font-lexend tw-font-normal tw-mb-2 tw-leading-6 tw-text-gray-800" i18n="@@talkToHairDoctor">Talk to a hair doctor</h1>
      <p
        *ngIf="showWorkingHours && regimenClass === ApiClientConstant.Regimen.Class.FACE"
        i18n="@@arrangeConsultationAfterWorkingHoursFace"
        class="tw-font-body tw-leading-5 tw-font-normal tw-text-300 tw-text-gray-400 tw-mb-4"
      >
        We will arrange an online consultation with a skin doctor within {{ hours }} {{ hours > 1 ? ' hours' : ' hour' }}.
      </p>
      <p
        *ngIf="showWorkingHours && regimenClass === ApiClientConstant.Regimen.Class.HAIR"
        i18n="@@arrangeConsultationAfterWorkingHoursHair"
        class="tw-font-body tw-leading-5 tw-font-normal tw-text-300 tw-text-gray-400 tw-mb-4"
      >
        We will arrange an online consultation with a hair doctor within {{ hours }} {{ hours > 1 ? ' hours' : ' hour' }}.
      </p>
      <p
        *ngIf="showTomorrowMorning && regimenClass === ApiClientConstant.Regimen.Class.FACE"
        i18n="@@arrangeConsultationAfterTomorrowMorningFace"
        class="tw-font-body tw-leading-5 tw-font-normal tw-text-300 tw-text-gray-400 tw-mb-4"
      >
        We will arrange an online consultation with a skin doctor tomorrow morning.
      </p>
      <p
        *ngIf="showTomorrowMorning && regimenClass === ApiClientConstant.Regimen.Class.HAIR"
        i18n="@@arrangeConsultationAfterTomorrowMorningHair"
        class="tw-font-body tw-leading-5 tw-font-normal tw-text-300 tw-text-gray-400 tw-mb-4"
      >
        We will arrange an online consultation with a hair doctor tomorrow morning.
      </p>
      <p
        *ngIf="showAfterNineAm && regimenClass === ApiClientConstant.Regimen.Class.FACE"
        i18n="@@arrangeConsultationAfter9amFace"
        class="tw-font-body tw-leading-5 tw-font-normal tw-text-300 tw-text-gray-400 tw-mb-4"
      >
        We will arrange an online consultation with a skin doctor after 9 am.
      </p>
      <p
        *ngIf="showAfterNineAm && regimenClass === ApiClientConstant.Regimen.Class.HAIR"
        i18n="@@arrangeConsultationAfter9amHair"
        class="tw-font-body tw-leading-5 tw-font-normal tw-text-300 tw-text-gray-400 tw-mb-4"
      >
        We will arrange an online consultation with a hair doctor after 9 am.
      </p>
      <div class="tw-w-full tw-h-[1px] tw-bg-[#CECECE] tw-mb-4"></div>
      <div class="tw-w-full tw-flex tw-justify-between tw-items-center tw-mb-1">
    <span class="tw-px-4 tw-py-2 tw-pb-2.5 tw-flex tw-items-center tw-gap-2 tw-font-semibold tw-bg-teal-600 tw-text-white tw-rounded-xl">
      <h1 class="" i18n="@@requestACall">Request a call</h1>
      <span class="tw-h-4 tw-w-4 tw-text-white">
          <svg viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M6.16185 15.4167L4.97852 14.2333L10.4618 8.75L4.97852 3.26667L6.16185 2.08334L12.8285 8.75L6.16185 15.4167Z" fill="currentColor"/>
          </svg>
        </span>
    </span>
        <span class="tw-flex tw-items-center">
      <img src="https://cdn.cureskin.com/app/img/doctor_ai.svg" class="tw-w-[35px] tw-h-[35px] -tw-mr-3" alt="doctor icon" />
      <img src="https://cdn.cureskin.com/app/img/phone_teal.svg" class="tw-w-[39px] tw-h-[39px]" alt="phone icon" />
    </span>
      </div>
    </div>
  </ng-container>
</ng-container>
